import { useEffect } from 'react';

const useDeselectBoardOnUnload = (game_id, board_id) => {
  useEffect(() => {
    const handleUnload = () => {
      console.log('rizzer pro max ........................');

      const url = `${process.env.REACT_APP_API_URL}/jackpot/clean_up_selected_board`;

      if (!game_id || !board_id) return;

      const data = JSON.stringify({ game_id, board_id });
      const blob = new Blob([data], { type: 'application/json' });

      console.log(navigator.sendBeacon(url, data));
      console.log(`Sent deselect request for board ${board_id}`);
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, [game_id, board_id]);
};

export default useDeselectBoardOnUnload;
